import React from 'react';
import { DivTag, SpanTag } from '../../Utils/AtomicTag';
import { atomicMapSlider } from './atomicMap';
var Track = function (props) {
    var _a, _b;
    var className = props.className, direction = props.direction, marks = props.marks;
    var length = props.length, offset = props.offset, reverse = props.reverse;
    var caleOffset = offset;
    if (length < 0) {
        reverse = !reverse;
        length = Math.abs(length);
        caleOffset = 100 - offset;
    }
    var positonStyle = direction
        ? (_a = {},
            _a[reverse ? 'top' : 'bottom'] = caleOffset + "%",
            _a[reverse ? 'bottom' : 'top'] = 'auto',
            _a.height = length + "%",
            _a) : (_b = {},
        _b[reverse ? 'right' : 'left'] = caleOffset + "%",
        _b[reverse ? 'left' : 'right'] = 'auto',
        _b.width = length + "%",
        _b);
    var elStyle = Object.assign({
        borderRadius: '4px',
        boxShadow: 'inset 0px 1px 2px 0px rgba(0,0,0,0.09)',
    }, positonStyle);
    var dot = [
        'absolute',
        'w-px-8',
        'h-px-8',
        'rounded-half',
        'border',
        'border-solid',
        'border-gray-400',
        'bg-gray-100',
    ];
    var activeDot = [
        'absolute',
        'w-px-8',
        'h-px-8',
        'rounded-half',
        'border',
        'border-solid',
        'bg-white',
        'border-brand-600',
    ];
    var dotBox = ['absolute', 'h-px-8', 'rounded-md', 'w-full'];
    var markBox = ['absolute', 'rounded-md', 'w-full'];
    var mark = [
        'absolute',
        'text-sm',
        'text-gray-600',
        'text-center',
        'inline-block',
    ];
    var vTrack = ['absolute', 'w-px-8', 'rounded-md', 'bg-brand-600'];
    if (direction) {
        dotBox = ['absolute', 'w-px-8', 'rounded-md', 'h-full'];
        markBox = ['absolute', 'rounded-md', 'h-full'];
    }
    var renderDot = function () {
        var l = Object.keys(marks).length;
        var dots = Object.keys(marks).map(function (m, i) {
            var style = {};
            if (direction) {
                style =
                    i == 0 || i == l - 1
                        ? { bottom: m + "%", left: 0, marginBottom: '-4px' }
                        : { bottom: m + "%", left: 0, marginBottom: '-4px' };
            }
            else {
                style =
                    i == 0 || i == l - 1
                        ? { left: m + "%", top: 0, marginLeft: '-4px' }
                        : { left: m + "%", top: 0, marginLeft: '-4px' };
            }
            return (React.createElement(SpanTag, { key: "m-" + i, atomics: length <= Number(m) ? dot : activeDot, style: style }));
        });
        return dots;
    };
    var renderMarks = function () {
        var l = Object.keys(marks).length;
        var dots = Object.keys(marks).map(function (m, i) {
            var style = {};
            if (direction) {
                style =
                    i == 0 || i == l - 1
                        ? { left: '14px', bottom: m + "%", transform: 'translateY(+50%)', marginTop: '8px' }
                        : { left: '14px', bottom: m + "%", transform: 'translateY(+50%)', marginTop: 0 };
            }
            else {
                style =
                    i == 0 || i == l - 1
                        ? { top: '14px', left: m + "%", transform: 'translateX(-50%)', marginLeft: 0 }
                        : { top: '14px', left: m + "%", transform: 'translateX(-50%)' };
            }
            return (React.createElement(SpanTag, { key: "m-mark-" + i, atomics: mark, style: style }, marks[Object.keys(marks)[i]]));
        });
        return dots;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DivTag, { atomics: direction ? vTrack : atomicMapSlider.trackStyle, className: className, style: elStyle }),
        React.createElement(DivTag, { atomics: dotBox }, Object.keys(marks).length > 0 ? renderDot() : null),
        React.createElement(DivTag, { atomics: markBox }, Object.keys(marks).length > 0 ? renderMarks() : null)));
};
export default Track;
